module.exports = __webpack_public_path__ + "img/1.aefee79c.png";